import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EngageRequestComponent } from '../engage-request.component';
interface DialogData {}

@Component({
  selector: 'app-appoinment-success-popup',
  templateUrl: './appoinment-success-popup.component.html',
  styleUrls: ['./appoinment-success-popup.component.scss']
})
export class AppoinmentSuccessPopupComponent implements OnInit {
  appoinmentsDetails: any;

  constructor(private dialogRef: MatDialogRef<EngageRequestComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.appoinmentsDetails = this.data["data"] 
  }

  closePop() {
    this.dialogRef.close({ data: 'Confirm' });
  }
}
